import { settingsRoutes } from "@/app";
import { IconArrowLeft } from "@/assets/icons/geist/IconArrowLeft";
import { Link } from "@/components/flexkit/Link";
import { ResizableHandle } from "@/components/flexkit/Resizable";
import { ScrollArea } from "@/components/flexkit/ScrollArea";
import { OrgSwitcherNew } from "@/components/OrgSwitcherNew";
import { cn } from "@/components/podkit/lib/cn";
import { SettingsMenu } from "@/components/settings/SettingsMenu";
import { ResizableSidebar } from "@/components/SidebarLayout";
import { Tooltip } from "@/components/Tooltip";
import { KeyboardCombo } from "@/components/keyboard/KeyboardCombo";
import { TrackLocations } from "@/hooks/use-segment";
import type { MenuItem } from "@/menu-item";
import { populateMenuFromRoute } from "@/menu-item";
import { useMemo, type FC } from "react";

export const SettingsSidebar: FC<{ className?: string; minWidth?: number; maxWidth?: number }> = ({
    className,
    minWidth,
    maxWidth,
}) => {
    return (
        <ResizableSidebar className={className} minWidth={minWidth} maxWidth={maxWidth}>
            <div data-testid="sidebar" className="flex size-full flex-col pb-[6px] pt-0.5">
                <div className="px-4 pt-2">
                    <SidebarHeader />
                </div>
                <ScrollArea orientation="vertical" className="mr-0.5 flex-grow pr-[1px] pt-2">
                    <SidebarContent />
                </ScrollArea>
                <div className="p-2 pb-2 pt-4">
                    <OrgSwitcherNew
                        data-track-location={TrackLocations.SettingsSidebarOrgSwitcher}
                        hideUserSettings
                        hideKeyboardShortcuts
                        isLocked
                    />
                </div>
            </div>
            <ResizableHandle className="top-4 mr-[1px] h-[calc(100%-32px)]" />
        </ResizableSidebar>
    );
};

const SidebarHeader: FC = () => {
    return (
        <Tooltip
            content={
                <div className="flex flex-row items-center gap-2">
                    Back to Ona
                    <KeyboardCombo keys={["Esc"]} />
                </div>
            }
        >
            <Link
                className="flex h-8 flex-row items-center gap-1 rounded-lg hover:bg-surface-03"
                to="/"
                reloadIfFrontendUpdated={true}
            >
                <div className="w-5">
                    <IconArrowLeft size="base" />
                </div>

                <div className={cn("flex-grow truncate text-start text-base font-bold")}>Back to Ona</div>
            </Link>
        </Tooltip>
    );
};

const SidebarContent: FC = () => {
    const menu: MenuItem[] = useMemo(() => populateMenuFromRoute(settingsRoutes), []);
    return <SettingsMenu menu={menu} />;
};
